import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import documentsToSignImage from '@/assets/images/documentsToSignImage.png';
import { Link } from 'react-router-dom';
import { getPropertyAddress } from '@/utils/properties';

const SignDocument = ({ firstDocAvailableToSign, property, link }) => {
  // const createdDate = new Date(firstDocAvailableToSign?.createdDate);
  // const hours = String(createdDate.getHours()).padStart(2, '0');
  // const minutes = String(createdDate.getMinutes()).padStart(2, '0');
  // const createdTimeText = `${hours}:${minutes}`;
  // const toSignDateOnly = new Date(createdDate);
  // toSignDateOnly.setDate(toSignDateOnly.getDate() + 25);
  //
  // const createdDateText = toSignDateOnly.toLocaleDateString('nb-NO', {
  //   weekday: 'long',
  //   day: 'numeric',
  //   month: 'long',
  // });
  return (
    <Card className="flex flex-col-reverse sm:flex-row justify-between m-2 sm:m-6 p-6 sm:p-8 gap-3 w-full">
      <div className="flex justify-between items-start flex-col gap-2">
        <h2 className="text-xl font-medium tracking-normal">
          Ny tilstandsrapport til signering
        </h2>
        <p className="text-sm leading-[21px] max-w-[560px] font-normal tracking-normal">
          En ny tilstandsrapport fra{' '}
          <span className="font-medium">
            {firstDocAvailableToSign?.companyName}
          </span>{' '}
          for{' '}
          <span className="font-medium">{getPropertyAddress(property)}</span> er
          klar for å sees over og signeres.{' '}
          {/* Husk å signere innen{' '}
          {createdDateText}, kl {createdTimeText}. */}
        </p>
        <Button asChild className="mt-2">
          <Link to={link}>Til rapporten</Link>
        </Button>
      </div>
      <img
        className="self-center max-w-[132px]"
        alt="document signing"
        src={documentsToSignImage}
      />
    </Card>
  );
};

export default SignDocument;
